import React from 'react';
import ComponentCloakLoading from '../../../../components/ComponentCloakLoading';
import classes from './styles/index.module.scss';

export const CommonLoading = (props) => (
	<ComponentCloakLoading
		className={classes.commonLoading}
		{...props}
	/>
);
